module.exports = __webpack_public_path__ + "static/img/18.b4a84702.jpg";